import {FC, Fragment, useEffect, useRef, useState} from "react";
import cls from "../maintenance.module.scss"

const calculateSecondsBetweenDates = (endDate: string) => {
    const startDateMs = new Date().getTime();
    const endDateMs = new Date(endDate).getTime();
    const differenceMs = endDateMs - startDateMs;

    return Math.floor(differenceMs / 1000);
}

const formatTime = (time: number) => {
    let days: string = String(Math.floor(time / 86400));
    let hours: string = String(Math.floor((time - (Number(days) * 86400)) / 3600));
    let minutes: string = String(Math.floor(((time - (Number(days) * 86400)) - (Number(hours) * 3600)) / 60));
    let seconds: string = String(Math.floor(((time - (Number(days) * 86400)) - (Number(hours) * 3600)) - (Number(minutes) * 60)));

    if (Number(days) < 10) days = "0" + days;
    if (Number(hours) < 10) hours = "0" + hours;
    if (Number(minutes) < 10) minutes = "0" + minutes;
    if (Number(seconds) < 10) seconds = "0" + seconds;
    return {
        days, hours,
        min: minutes, sec: seconds
    }
}

const CountDown:FC<{ endDate: string }> = ({ endDate }) => {
    const [countdown, setCountdown] = useState<number>(
        calculateSecondsBetweenDates(endDate)
    );
    const timerId = useRef({});

    useEffect(() => {
        timerId.current = setInterval(() => {
            setCountdown((prevState) => prevState - 1)
        }, 1000)
        return () => clearInterval(timerId.current as any)
    }, [])

    useEffect(() => {
        if (countdown <= 0) {
            clearInterval(timerId.current as any)
        }
    }, [countdown]);

    const countArray = formatTime(countdown);
    return countdown > 0 ? (
        <div className={cls.countdown_wrapper}>
            {Object.keys(countArray).map((elem, index, array) => {
                return (
                    <div className={cls.date_row} key={index}>
                        <div className={cls.date_column}>
                            <p className={cls.column_count}>
                                <b>{countArray[elem as "days" | "hours" | "min" | "sec"]}</b>
                            </p>
                            <p className={cls.column_title}>{elem}</p>
                        </div>
                        <p className={cls.column_count}>
                            <b>{index !== array.length - 1 && " :"}</b>
                        </p>
                    </div>
                )
            })}
        </div>
    ) : <Fragment />
}

export default CountDown;
